import React, { useState } from "react";
import { Icon } from "@iconify/react";
import NotificationModal from "../../modals/notificationModal";
import AllReminderModal from "../../modals/allReminderModal";
import { useNavigate } from "react-router-dom";
import { generateRandomId } from "../../utils/helpers";
import { useTranslation } from "react-i18next";

const languages = [
  {
    code: "en",
    label: "English",
    icon: "twemoji:flag-for-flag-united-states",
  },
  { code: "fr", label: "Français", icon: "twemoji:flag-for-flag-france" },
  { code: "de", label: "Deutsch", icon: "twemoji:flag-for-flag-germany" },
  {
    code: "ar",
    label: "العربية",
    icon: "twemoji:flag-for-flag-saudi-arabia",
  },
];

const Dashnavbar = ({ toggleDrawer }) => {
  const navigate = useNavigate();
  const [isnotifyModelOpen, setisnotifyModelOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const [allReminderModalOpen, setallReminderModalOpen] = useState(false);
  const randomId = generateRandomId();
  const toggleDropdown = () => setIsOpen(!isOpen);
  const { t, i18n } = useTranslation();

  const selectLanguage = (language) => {
    setSelectedLanguage(language);
    setIsOpen(false);
    i18n.changeLanguage(language.code);
  };
  const openNotificationModal = () => {
    setisnotifyModelOpen(true);
  };
  const openAllReminderModal = () => {
    setallReminderModalOpen(true);
  };

  return (
    <>
      <div className="dashnavbar-container h-fit flex items-center justify-between w-[calc(100vw-310px)] max-md:w-full">
        <div className="dashnav-left">
          <Icon
            icon="ion:menu"
            width={20}
            height={20}
            onClick={toggleDrawer}
            className="hidden max-md:flex cursor-pointer"
          />
        </div>

        <div className="dashnav-right w-100 flex justify-end gap-[15px] sm-s:gap-[8px]">
          {/* reminders */}
          <div
            className="cursor-pointer h-[45px] sm-s:h-[40px] flex items-center gap-[5px] txt-color rounded-[28.5px] p-[8px] border-[1.299px] border-white bg-[rgba(255,255,255,0.30)] shadow-[0px_11px_23.2px_#E1E2EF] backdrop-blur-[72.719px]"
            onClick={openAllReminderModal}
          >
            <Icon
              icon="lets-icons:clock"
              width={28}
              height={28}
              className="sm-s:h-[22px] sm-s:w-[22px]"
            />
            <p className="font-medium medium">{t("dashboard.reminders")}</p>
          </div>
          {/* langugae dropdown */}
          <div className="relative inline-block text-left">
            <div
              className="flex items-center justify-between gap-2 cursor-pointer w-[85px] h-[45px] sm-s:h-[40px] sm-s:w-[70px] txt-color rounded-[28.5px] p-[8px] border-[1.299px] border-white bg-[rgba(255,255,255,0.30)] shadow-[0px_11px_23.2px_#E1E2EF] backdrop-blur-[72.719px]"
              onClick={toggleDropdown}
            >
              <Icon icon={selectedLanguage.icon} width={28} height={28} />
              <Icon
                icon="mdi:chevron-down"
                width={26}
                height={26}
                color="#718096"
                className="sm-s:h-[22px] sm-s:w-[22px]"
              />
            </div>
            {isOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg z-10">
                <ul className="py-1">
                  {languages.map((language) => (
                    <li
                      key={language.code}
                      className="flex items-center gap-2 px-4 py-2 cursor-pointer hover:bg-gray-200"
                      onClick={() => selectLanguage(language)}
                    >
                      <Icon icon={language.icon} width={24} height={24} />
                      <span className="text-black font-medium">{language.label}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          {/* notification */}
          <div className="relative flex justify-center items-center w-[45px] h-[45px] sm-s:h-[40px] sm-s:w-[40px] txt-color rounded-[28.5px] p-[8px] border-[1.299px] border-white bg-[rgba(255,255,255,0.30)] shadow-[0px_11px_23.2px_#E1E2EF] backdrop-blur-[72.719px]">
            <Icon
              icon="material-symbols-light:notifications-outline-sharp"
              width={28}
              height={28}
              onClick={openNotificationModal}
              className="cursor-pointer relative sm-s:h-[22px] sm-s:w-[22px]"
            />
            <div
              onClick={openNotificationModal}
              className="cursor-pointer w-[8px] h-[8px] bg-[#00BBDD] rounded-[50px] absolute top-[25%] right-[30%]"
            ></div>
          </div>
          {/*Settings button */}
          <div
            className="w-[45px] h-[45px] sm-s:h-[40px] sm-s:w-[40px] cursor-pointer rounded-[31px] flex items-center justify-center py-[3px] px-[16px] bg-[var(--Primary-color,#143A62)] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)] backdrop-blur-[72.719px]"
            onClick={() => navigate("/settings")}
          >
            <h6 className="uppercase text-white font-semibold sm-s:text-[18px]">t</h6>
          </div>
        </div>
      </div>

      {/* Modals */}
      <AllReminderModal
        allReminderModalOpen={allReminderModalOpen}
        setallReminderModalOpen={setallReminderModalOpen}
      />
      <NotificationModal
        isnotifyModelOpen={isnotifyModelOpen}
        setisnotifyModelOpen={setisnotifyModelOpen}
      />
    </>
  );
};

export default Dashnavbar;
